import { useState, useEffect } from 'react';

import { useQuery, gql, throwIfQueryError } from '@zenbusiness/application-commons-graphql';
import Button from '@zenbusiness/zui/Button';
import LinearProgress from '@zenbusiness/zui/LinearProgress';
import Stack from '@zenbusiness/zui/Stack';

export default function ErrorDebugging() {
  const [showRenderError, setShowRenderError] = useState();
  const [showEffectError, setShowEffectError] = useState();
  const [showBadGraphQLError, setShowBadGraphQLError] = useState(0);
  const [showResolverError, setShowResolverError] = useState(0);

  return (
    <Stack spacing="12px">
      {/* eslint-disable-next-line no-undef */}
      <Button onClick={() => methodDoesNotExist}>Trigger undefined function</Button>

      <Button onClick={setShowRenderError}>Trigger error in component render</Button>
      {showRenderError && <RenderError />}

      <Button onClick={setShowEffectError}>Trigger error in component effect</Button>
      {showEffectError && <EffectError />}

      <Button onClick={() => setShowBadGraphQLError(showBadGraphQLError + 1)}>
        Trigger error in graphql query
      </Button>
      {!!showBadGraphQLError && <BadGraphQLError key={showBadGraphQLError} />}

      <Button onClick={() => setShowResolverError(showResolverError + 1)}>
        Trigger error in graphql resolver
      </Button>
      {!!showResolverError && <ResolverError key={showResolverError} />}
    </Stack>
  );
}

function RenderError() {
  throw new Error('Error triggered during render');
}

function EffectError() {
  useEffect(() => {
    throw new Error('Error triggered during an effect.');
  });
}

function BadGraphQLError() {
  const { loading, error } = useQuery(
    gql`
      query BadRequest {
        missing {
          uuid
        }
      }
    `,
    {
      noThrow: true
    }
  );

  throwIfQueryError(error);

  if (loading) {
    return <LinearProgress />;
  }

  return <span>wheres the error?</span>;
}

function ResolverError() {
  const { loading, error } = useQuery(gql`
    query ResolverError {
      throwsError
    }
  `);
  throwIfQueryError(error);

  if (loading) {
    return <LinearProgress />;
  }

  return <span>wheres the error?</span>;
}
